// resolveDispatchModel.js — modelo de um re-dispatch INTERNO do turno (plan
// approve/replan, blocker action, fila de envio, auto-first-message).
// @arch:pure-engine
//
// Bug (2026-07-13): esses caminhos caíam em session.model, que fica STALE vs o
// pick VIVO do dropdown — handleModelChange faz updateCodeSession ASSÍNCRONO, então
// entre o pick e o re-dispatch o session.model ainda é o antigo → o turno rodava o
// modelo salvo da sessão em vez do escolhido. Prioridade: pick explícito do turno >
// ui.model (o que o dropdown MOSTRA, síncrono) > model salvo da sessão.
export function resolveDispatchModel(argsModel, uiModel, sessionModel) {
  return argsModel || uiModel || sessionModel || null;
}
